(function() {
    'use strict';

    angular
        .module('costCenters')
        .controller('CostCentersController', CostCentersController);

    /* @ngInject */
    function CostCentersController($scope, $state, $uibModal, toastr, CostCentersService, CostCenter) {
        var vm = this;

        // /* Bindable methods */
        vm.create = create;
        vm.edit = edit;
        vm.remove = remove;
        vm.name = '';
        vm.list = list;

        vm.getByFilter = getByFilter;
        vm.activate = activate;

        vm.queryFlag = false;
        
        /* View rendering */
        /*
        var view = {
            renderers: { 
                'root.costCenters.list': list 
            },
            init: () => view.renderers[$state.current.name](),
            refresh: () => {$state.go($state.current, $state.params, { reload: true })},
        };
        */

        function activate()
        {
            vm.getByFilter();
        }

        activate();

        /* Pagination */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }
        
        // Initializing view
        //view.init();
        
        /* Implementation details */
        function create() {
            form();
        }
        
        function edit(costCenter) {
            var costCenter = new CostCenter(costCenter);
            form(costCenter);
        }

        function getByFilter()
        {
            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(vm.name !== '') {
                vm.query['name'] = vm.name;
            }
            CostCentersService.getByFilter(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.costCenters      = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);

                if (!vm.costCenters || !vm.costCenters.length) {
                    vm.resultMessage = 'Sorry, no results were found!';
                }
            });
        }

        function list() {
            if(vm.name !== ''){
                $state.params.filters['name'] = vm.name;
            }
            /* Model Collection */
            vm.costCenters = CostCentersService.costCenters;

            /* Pagination */
            vm.pagination = {
                pageChanged: pageChanged,
                currentPage: CostCentersService.currentPage,
                totalItems: CostCentersService.totalItems,
                to: CostCentersService.to,
                itemsPerPage: CostCentersService.itemsPerPage,
            }
            
            /* No results */
            if (!vm.costCenters || !vm.costCenters.length) {   
                vm.resultMessage = 'Sorry, no results were found!';
            }


    
            /* Implementation details */
            function pageChanged () {
                $state.params.filters = $state.params.filters || {};
                $state.params.filters['page'] = vm.pagination.currentPage || 1;
                view.refresh();
            }
        }

        function remove(id) {
            alertify
                .confirm('Do you really want to delete this cost center?<br>This action is irreversible!')
                .set('labels', {
                    ok: 'Yes, delete this cost center',
                    cancel: 'No'
                })
                .set('title', 'Delete Cost Center')
                .set('onok', function () {
                    CostCentersService.deleteCostCenter(id)
                    .then(() => toastr.success('Cost center successfully deleted'))
                    .catch(() => toastr.error('Something went wrong. Please try again later'))
                    .finally(() => view.refresh());
                })
                .show();
        }

        function form(costCenter) {
            var costCenters;
            
            CostCentersService.getAllCostCenters()
                .then(res => costCenters = res.data)
                .then(() => $uibModal.open({
                    templateUrl: 'templates/costCenters/templates/costCenters-form.html',
                    controller: ['$uibModalInstance', function ($uibModalInstance) {
                        var modal = this;
                        
                        /* Cost Center Model */
                        modal.costCenter = costCenter || new CostCenter();
                        
                        /* Bindable methods */
                        modal.cancel = $uibModalInstance.close;
                        modal.save = save;

                        /* Form */
                        modal.costCenters = costCenters;
                        modal.form_error = false;
                        
                        function save() {
                            modal.form_error = true;
                            if(!modal.costCenter.name) {
                                return;
                            }
                            modal.form_error = false;

                            var method;

                            if (modal.costCenter.id) {
                                method = 'updateCostCenter'
                            }
                            else {
                                method = 'createCostCenter';
                            }

                            CostCentersService[method](modal.costCenter)
                                .then(() => {
                                    toastr.success('Cost Center successfully saved');
                                    modal.cancel();
                                    view.refresh();
                                })
                                .catch(res => {
                                    switch (res.data.message) {
                                        case 'SQLSTATE[23000]' || 'validator':
                                            toastr.error('Name already taken, please choose another one');
                                            break;
                                        case 'circular_dependency':
                                            toastr.error('Invalid value for Parent Cost Center');
                                            break;                                    
                                        default:
                                            toastr.error('Something went wrong. Please try again later');
                                            break;
                                    }
                                });
                        }
                    }],
                    controllerAs: 'modal',
                }));
        }
    }
})();